module.exports = __webpack_public_path__ + "static/img/transfer.34c76cbb.png";